export enum CustomerCredibilityEnum {
  Not_Evaluated = "NOT_EVALUATED",
  Low = "LOW",
  Medium = "MEDIUM",
  Trusted = "TRUSTED",
  Fully_Trusted = "FULLY_TRUSTED",
}
